import levels from './levels';
import {getConfigItem, configConstants, observeConfigItem} from '@servicenow/ui-config';

const {METRICS_LEVEL, METRICS_TYPES, TELEMETRY_MARKING_ENABLED, METRICS_ELEMENT_CONFIG_ENABLED} =
	configConstants;

let globalMetricsLevel = parseInt(getConfigItem(METRICS_LEVEL));
let globalMetricsLevelIsInteger = Number.isInteger(globalMetricsLevel);
let globalMetricTypes = getConfigItem(METRICS_TYPES);
let globalIsTelemetryEnabled = getConfigItem(TELEMETRY_MARKING_ENABLED);
let globalElementMetricsConfigEnabled = getConfigItem(METRICS_ELEMENT_CONFIG_ENABLED);

let resolvedLevels = {};
const isMetricTypeValid = level => {
	if (resolvedLevels[level]) return true;

	const isValid = Number.isInteger(level) && level >= 0 && level <= 5;

	if (isValid) resolvedLevels[level] = true;

	return isValid;
};

const observer = (path, value) => {
	resolvedLevels = {};

	switch (path) {
		case METRICS_LEVEL:
			globalMetricsLevel = value;
			globalMetricsLevelIsInteger = Number.isInteger(globalMetricsLevel);
			break;
		case METRICS_TYPES:
			globalMetricTypes = value;
			break;
		case TELEMETRY_MARKING_ENABLED:
			globalIsTelemetryEnabled = value;
			break;
		case METRICS_ELEMENT_CONFIG_ENABLED:
			globalElementMetricsConfigEnabled = value;
			break;
	}
};

observeConfigItem(METRICS_LEVEL, observer);
observeConfigItem(METRICS_TYPES, observer);
observeConfigItem(TELEMETRY_MARKING_ENABLED, observer);
observeConfigItem(METRICS_ELEMENT_CONFIG_ENABLED, observer);

export default function shouldMark(context, metricType) {
	if (globalIsTelemetryEnabled === false) return false;

	// non-bootstrapped components don't have enough
	// data to send a valid mark
	if (!context.ready) return false;

	if (globalElementMetricsConfigEnabled && Array.isArray(context.nowMetricTypes))
		return context.nowMetricTypes.includes(metricType);

	if (Array.isArray(globalMetricTypes)) return globalMetricTypes.includes(metricType);

	const level = levels[metricType];

	if (!isMetricTypeValid(level)) return false;

	if (globalElementMetricsConfigEnabled && Number.isInteger(context.nowMetricsLevel))
		return level >= context.nowMetricsLevel;

	return globalMetricsLevelIsInteger && level >= globalMetricsLevel;
}
